export default __webpack_public_path__ + "static/media/Ellipse-23.2b4b3b47.png";